<main class="tree-page">
  <div class="tree-content">
    <div class="brand-mark">
      <img src="assets/icon.png" alt="Rast-WC Logo" />
    </div>

    <h1>Rast-WC.de</h1>
    <p class="tagline">Saubere Pausen. Bessere Reisen.</p>

    <nav class="link-list" aria-label="Rast-WC Links">
      @for (link of links; track link.href) {
        <a class="tree-link" [href]="link.href" target="_blank" rel="noopener noreferrer">
          <span class="link-icon" aria-hidden="true">
            <mat-icon>{{ link.icon }}</mat-icon>
          </span>
          <span class="link-copy">
            <span class="link-label">{{ link.label }}</span>
            <span class="link-description">{{ link.description }}</span>
          </span>
          <mat-icon class="link-arrow" aria-hidden="true">open_in_new</mat-icon>
        </a>
      }
    </nav>

    <p class="footer-copy">Rast-WC.de · Für entspannte Pausen unterwegs</p>
  </div>
</main>
